module.exports = __webpack_public_path__ + "img/milken.dba67acd.jpg";